var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MessageModal',{attrs:{"message":_vm.message},scopedSlots:_vm._u([{key:"message-body",fn:function(){return [_vm._v(_vm._s(_vm.$t('error.system'))+": "+_vm._s(_vm.message.text))]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }